import {
  del,
  get,
  patch,
  post,
  type RequestConfig,
} from "../shared/api-client";
import type {
  ApiItemResponse,
  ListQuery,
  PaginatedResult,
} from "@project/types/location";
import {
  JIVANDHARA_BASE,
  SILENT_LIST,
  fetchListPage,
  unwrapItem,
} from "./list-api-helpers";

export interface TiffinSevaScheme {
  id: number;
  name: string;
  price: string;
  is_active: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface TiffinSevaSchemePayload {
  name: string;
  price: string;
  is_active: boolean;
}

const BASE = `${JIVANDHARA_BASE}/tiffin-seva-schemes`;
const SILENT: RequestConfig = { showNotification: false };

class TiffinSevaSchemeService {
  listPage = (query: ListQuery = {}): Promise<PaginatedResult<TiffinSevaScheme>> =>
    fetchListPage<TiffinSevaScheme>(`${BASE}/`, query);

  get = async (id: number): Promise<TiffinSevaScheme | undefined> => {
    const data = await get<ApiItemResponse<TiffinSevaScheme> | TiffinSevaScheme>(
      `${BASE}/${id}/`,
      SILENT_LIST
    );
    return unwrapItem(data);
  };

  create = async (payload: TiffinSevaSchemePayload): Promise<TiffinSevaScheme> => {
    const data = await post<
      ApiItemResponse<TiffinSevaScheme> | TiffinSevaScheme,
      TiffinSevaSchemePayload
    >(`${BASE}/`, payload, SILENT);
    const item = unwrapItem(data);
    if (!item) {
      throw new Error("Failed to create tiffin seva scheme.");
    }
    return item;
  };

  update = async (
    id: number,
    payload: Partial<TiffinSevaSchemePayload>
  ): Promise<TiffinSevaScheme | undefined> => {
    const data = await patch<
      ApiItemResponse<TiffinSevaScheme> | TiffinSevaScheme,
      Partial<TiffinSevaSchemePayload>
    >(`${BASE}/${id}/`, payload, SILENT);
    return unwrapItem(data);
  };

  delete = async (id: number): Promise<void> => {
    await del(`${BASE}/${id}/`, SILENT);
  };
}

export const tiffinSevaSchemeService = new TiffinSevaSchemeService();
